import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InspireComponent } from './inspire.component';
import { SharedModule } from '../shared/shared.module';
import { InspireHeroComponent } from './components/inspire-hero/inspire-hero.component';
import { InspirePresentationComponent } from './components/inspire-presentation/inspire-presentation.component';
import { ArrivedComponent } from './components/arrived/arrived.component';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { SubscribeModule } from '../subscribe/subscribe.module';



@NgModule({
  declarations: [
    InspireComponent,
    InspireHeroComponent,
    InspirePresentationComponent,
    ArrivedComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatCardModule,
    RouterModule,
    SubscribeModule
  ]
})
export class InspireModule { }
